import { custom, deserialize, serializable } from 'serializr';
import { Deserializable } from '@models/deserializable';
import { QtestFieldAllowedValueModel } from '@modules/test-development/models/qtest-field-allowed-value.model';

export class QtestIssueField implements Deserializable {
  @serializable
  public id: string;
  @serializable
  public label: string;
  @serializable
  public required: boolean;
  @serializable
  public systemField: boolean;
  @serializable
  public isActive: boolean;
  @serializable
  public multiple: boolean;
  @serializable
  public constrained: boolean;
  @serializable
  public attributeType: string;
  @serializable
  public originalName: string;
  @serializable
  public searchKey: string;
  @serializable(
    custom(
      (v) => v,
      (v) => {
        const returnValue: QtestFieldAllowedValueModel[] = [];
        (v || []).forEach((value) =>
          returnValue.push(
            new QtestFieldAllowedValueModel().deserialize(value),
          ),
        );
        return returnValue;
      },
    ),
  )
  public allowedValues: QtestFieldAllowedValueModel[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(QtestIssueField, input));
  }

  get isSummaryField(): boolean {
    return this.originalName == 'sum';
  }

  get isDescriptionField(): boolean {
    return this.originalName == 'des';
  }

  get isPriorityField(): boolean {
    return this.originalName == 'svt';
  }

  get isDueDateField(): boolean {
    return this.originalName == 'Target Date';
  }

  get isCustomField(): boolean {
    return !this.systemField;
  }

  get isCustomTextField(): boolean {
    return !this.systemField && this.attributeType === 'String';
  }

  get isCustomTextAreaField(): boolean {
    return !this.systemField && this.attributeType === 'LongText';
  }

  get isCustomSelect(): boolean {
    return (
      !this.systemField && this.attributeType === 'Number' && this.constrained
    );
  }

  get isCustomMultiSelect(): boolean {
    return !this.systemField && this.multiple;
  }

  get isCustomNumberField(): boolean {
    return !this.systemField && this.attributeType === 'Number';
  }

  get isCustomURLField(): boolean {
    return !this.systemField && this.attributeType === 'Url';
  }

  get canShowOnTSForm(): boolean {
    return (
      this.required ||
      this.isDescriptionField ||
      this.isPriorityField ||
      this.isDueDateField ||
      (this.isCustomField &&
        (this.isCustomURLField ||
          this.isCustomNumberField ||
          this.isCustomTextField ||
          this.isCustomTextAreaField ||
          this.allowedValues?.length > 0))
    );
  }

  get type(): string {
    if (this.isDescriptionField || this.isCustomTextAreaField)
      return 'textarea';
    else if (this.isSummaryField || this.isCustomTextField) return 'text';
    else if (this.isCustomNumberField) return 'number';
    else if (this.isCustomURLField) return 'url';
    else if (this.isPriorityField) return 'priority';
    else if (
      this.isCustomSelect ||
      this.isCustomMultiSelect ||
      this.isPriorityField
    )
      return 'dropdown';
    else if (this.isDueDateField) return 'date';
  }
}
